import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=524d733c&scoped=true"
import script from "./Button.vue?vue&type=script&setup=true&lang=ts"
export * from "./Button.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Button.vue?vue&type=style&index=0&id=524d733c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d733c",
  null
  
)

export default component.exports